import { __assign } from "tslib";
import React, { useEffect, useRef, useState } from "react";
import { View, StyleSheet } from "react-native";
import { PnmacParagraph, PnmacCard, PnmacText, PnmacCheckBox, PnmacSelect, PnmacUIButton, PnmacMediaQuery, PnmacMeta, PnmacHtmlToNative } from "pnmac-universal-components";
import { textStyle } from "../../../v2/theme";
import { Link } from 'react-router-dom';
import { SuccessMessage } from "../../../components/SuccessMessage";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { getBorrowerContactRules } from "../../../redux/actions/actions";
var CommunicationNotificationView = function (props) {
  var layout = useSelector(function (store) {
    return store;
  });
  var dispatch = useDispatch();
  var translations = layout.translations;
  var borrowerId = parseInt(layout.borrowerId);
  var borrowerSummary = layout.currentLoan.borrowerSummary.filter(function (item) {
    return parseInt(item.borrowerId) === borrowerId;
  });
  var borrowerEmails = borrowerSummary.length > 0 && borrowerSummary[0].borrowerEmails || [];
  var borrowerPhones = borrowerSummary.length > 0 && borrowerSummary[0].borrowerPhones || [];
  var isEmailAdded = borrowerEmails.length > 0 && borrowerEmails.filter(function (item) {
    return item.validFlag === true;
  }).length > 0;
  var borrowerPhoneTypeMobile = borrowerPhones.length > 0 ? borrowerPhones.find(function (item) {
    return parseInt(item.phoneTypeId) === 3;
  }) : null;
  var isPhoneAdded = borrowerPhoneTypeMobile != null && borrowerPhoneTypeMobile.phoneNumber;
  var userEmail = "";
  var userPhone = "";
  if (isEmailAdded) {
    userEmail = borrowerEmails[0].emailAddress;
  }
  if (isPhoneAdded) {
    userPhone = borrowerPhoneTypeMobile.phoneNumber;
  }
  var _a = useState(false),
    loanServicingEmail = _a[0],
    setLoanServicingEmail = _a[1];
  var _b = useState(false),
    loanServicingMobile = _b[0],
    setLoanServicingMobile = _b[1];
  var _c = useState(false),
    digitalAlertEmail = _c[0],
    setDigitalAlertEmail = _c[1];
  var _d = useState(false),
    digitalAlertMobile = _d[0],
    setDigitalAlertMobile = _d[1];
  var _e = useState(false),
    paymentReminderEmail = _e[0],
    setPaymentReminderEmail = _e[1];
  var _f = useState(false),
    paymentReminderMobile = _f[0],
    setPaymentReminderMobile = _f[1];
  var _g = useState(0),
    paymentReminderDay = _g[0],
    setPaymentReminderDay = _g[1];
  var _h = useState(false),
    showSuccess = _h[0],
    setShowSuccess = _h[1];
  var _j = useState(false),
    loading = _j[0],
    setLoading = _j[1];
  var _k = useState(true),
    noChange = _k[0],
    setNoChange = _k[1];
  var isPaymentPreferenceUpdated = useRef(false);
  var getRadioButtonStatus = function (value) {
    return value ? 'checked' : 'unchecked';
  };
  useEffect(function () {
    dispatch(getBorrowerContactRules(borrowerId));
  }, [borrowerId]);
  useEffect(function () {
    var borrowerRules = layout.borrowerContactRules;
    if (borrowerRules && borrowerRules.length > 0) {
      var loanServicing = borrowerRules.filter(function (item) {
        return item.contactRuleScopeId === 1;
      }) || [];
      var digitalAlert = borrowerRules.filter(function (item) {
        return item.contactRuleScopeId === 2;
      }) || [];
      var paymentReminder = borrowerRules.filter(function (item) {
        return item.contactRuleScopeId === 3;
      }) || [];
      if (loanServicing.length > 0) {
        setLoanServicingEmail(loanServicing[0].emailConsentTypeId === 2 && isEmailAdded);
        setLoanServicingMobile(loanServicing[0].textConsentTypeId === 2 && isPhoneAdded);
      }
      if (digitalAlert.length > 0) {
        setDigitalAlertEmail(digitalAlert[0].emailConsentTypeId === 2 && isEmailAdded);
        setDigitalAlertMobile(digitalAlert[0].textConsentTypeId === 2 && isPhoneAdded);
      }
      if (paymentReminder.length > 0) {
        setPaymentReminderEmail(paymentReminder[0].emailConsentTypeId === 2 && isEmailAdded);
        setPaymentReminderMobile(paymentReminder[0].textConsentTypeId === 2 && isPhoneAdded);
        setPaymentReminderDay(parseInt(paymentReminder[0].paymentReminderDay));
      }
    } else {
      setLoanServicingEmail(false);
      setLoanServicingMobile(false);
      setDigitalAlertEmail(false);
      setDigitalAlertMobile(false);
      setPaymentReminderEmail(false);
      setPaymentReminderMobile(false);
      setPaymentReminderDay(0);
    }
    setNoChange(true);
  }, [layout.borrowerContactRules]);
  var updateRuleDataItem = function (item, emailAndTextConsentSpecified) {
    if (emailAndTextConsentSpecified === void 0) {
      emailAndTextConsentSpecified = null;
    }
    var tempItem = item;
    var emailConsentTypeIdPrevious = null;
    var textConsentTypeIdPrevious = null;
    var paymentReminderDayPrevious = null;
    if (emailAndTextConsentSpecified === null) {
      //keeping reference of previous values
      emailConsentTypeIdPrevious = tempItem.emailConsentTypeId;
      textConsentTypeIdPrevious = tempItem.textConsentTypeId;
      paymentReminderDayPrevious = tempItem.paymentReminderDay;
    }
    if (item.contactRuleScopeId === 1) {
      tempItem.emailConsentTypeId = loanServicingEmail ? 2 : isEmailAdded ? 3 : 1;
      tempItem.textConsentTypeId = loanServicingMobile ? 2 : isPhoneAdded ? 3 : 1;
      tempItem.paymentReminderDay = null;
    } else if (item.contactRuleScopeId === 2) {
      tempItem.emailConsentTypeId = digitalAlertEmail ? 2 : isEmailAdded ? 3 : 1;
      tempItem.textConsentTypeId = digitalAlertMobile ? 2 : isPhoneAdded ? 3 : 1;
      tempItem.paymentReminderDay = null;
    } else if (item.contactRuleScopeId === 3) {
      tempItem.paymentReminderDaySpecified = emailAndTextConsentSpecified === null ? paymentReminderDayPrevious !== paymentReminderDay : true;
      tempItem.emailConsentTypeId = paymentReminderEmail ? 2 : isEmailAdded ? 3 : 1;
      tempItem.textConsentTypeId = paymentReminderMobile ? 2 : isPhoneAdded ? 3 : 1;
      tempItem.paymentReminderDay = paymentReminderDay;
    }
    if (emailAndTextConsentSpecified === null) {
      tempItem.textConsentSpecified = textConsentTypeIdPrevious !== tempItem.textConsentTypeId;
      tempItem.emailConsentSpecified = emailConsentTypeIdPrevious !== tempItem.emailConsentTypeId;
    } else {
      tempItem.textConsentSpecified = true;
      tempItem.emailConsentSpecified = true;
      tempItem.borrowerId = borrowerId;
    }
    if (tempItem.textConsentSpecified === true) {
      tempItem.textConsentDate = moment().format("YYYY-MM-DD");
    }
    if (tempItem.emailConsentSpecified === true) {
      tempItem.emailConsentDate = moment().format("YYYY-MM-DD");
    }
    return tempItem;
  };
  var updateData = function () {
    var ruleScope = [{
      "contactRuleScopeId": 1
    }, {
      "contactRuleScopeId": 2
    }, {
      "contactRuleScopeId": 3
    }];
    var borrowerRules = layout.borrowerContactRules;
    //filtering from API response borrower contact rules.
    ruleScope = ruleScope.filter(function (item) {
      return borrowerRules.findIndex(function (i) {
        return i.contactRuleScopeId === item.contactRuleScopeId;
      }) < 0;
    });
    var newUpdateArray = borrowerRules.map(function (item) {
      return updateRuleDataItem(item);
    });
    if (ruleScope.length > 0) {
      var newRuleScopeArray = ruleScope.map(function (item) {
        return updateRuleDataItem(item, true);
      });
      newUpdateArray = newUpdateArray.concat(newRuleScopeArray);
    }
    if (newUpdateArray.length > 0) {
      setLoading(true);
      fetch("".concat(layout.pennyHomeUrl, "api/loan/update_borrower_contact_rules?borrowerId=") + borrowerId, {
        method: "POST",
        headers: {
          "Content-Type": "application/json; charset=utf-8",
          "Authorization": "Bearer ".concat(layout.token)
        },
        body: JSON.stringify(newUpdateArray)
      }).then(function (data) {
        return data.json();
      }).then(function (response) {
        setLoading(false);
        setNoChange(true);
        if (response) {
          setShowSuccess(true);
          dispatch(getBorrowerContactRules(borrowerId));
        }
      }).catch(function (e) {
        setNoChange(true);
        setLoading(false);
      });
    }
  };
  var disablePaymentReminderDayPicker = function () {
    var value = !paymentReminderEmail && !paymentReminderMobile;
    return value;
  };
  var getDatesForDayPicker = function () {
    var lastDayOfMonth = moment().endOf("month").date();
    var dateData = Array(28).fill(0).map(function (_, i) {
      return {
        'label': (i + 1).toString(),
        'value': i + 1
      };
    });
    dateData.push({
      'label': 'Last Day',
      'value': lastDayOfMonth
    });
    return dateData;
  };
  return /*#__PURE__*/React.createElement(PnmacMediaQuery, {
    queries: {
      small: "(max-width: 599px)",
      medium: "(min-width: 600px) and (max-width: 1199px)",
      mediumLarge: "(min-width: 1024px) and (max-width: 1199px)",
      large: "(min-width: 1200px)"
    }
  }, function (matches) {
    return /*#__PURE__*/React.createElement("div", {
      style: {
        width: "100%"
      }
    }, /*#__PURE__*/React.createElement(PnmacMeta, {
      title: "Notifications"
    }), /*#__PURE__*/React.createElement(PnmacCard, {
      style: {
        borderRadius: 10,
        marginTop: 10
      },
      elvation: 0
    }, /*#__PURE__*/React.createElement(View, {
      style: {
        padding: 25
      }
    }, /*#__PURE__*/React.createElement(PnmacText, {
      idTag: "textNotificationView",
      adjustsFontSizeToFit: true,
      style: textStyle.communicationNotificationSectionTitle
    }, translations.OptInOut_Notifications), showSuccess ? /*#__PURE__*/React.createElement(SuccessMessage, {
      onClick: function () {
        return setShowSuccess(false);
      },
      message: translations.MessageCenterSuccessMessage
    }) : null, /*#__PURE__*/React.createElement("span", {
      className: 'htmlToNative',
      dangerouslySetInnerHTML: {
        __html: translations.OptInOut_ManageOrUpdate
      }
    }), /*#__PURE__*/React.createElement(View, {
      style: {
        borderWidth: 1,
        borderColor: "#e9e9e9",
        padding: matches.small ? 5 : 20,
        marginTop: 20
      }
    }, /*#__PURE__*/React.createElement(View, {
      style: {
        flexDirection: "row"
      }
    }, /*#__PURE__*/React.createElement(View, {
      style: {
        flex: 1
      }
    }, /*#__PURE__*/React.createElement(PnmacParagraph, {
      style: textStyle.defaultTextTitle
    }, translations.EmailAddress, ":"), /*#__PURE__*/React.createElement(View, {
      style: {
        marginTop: 10
      }
    }, /*#__PURE__*/React.createElement(PnmacParagraph, {
      style: textStyle.defaultTextTitle
    }, translations.MobilePhoneNumber, ":"))), /*#__PURE__*/React.createElement(View, {
      style: {
        display: "flex",
        flexDirection: "column",
        marginLeft: 10,
        flex: 1
      }
    }, /*#__PURE__*/React.createElement(PnmacParagraph, {
      style: __assign({
        marginTop: 10
      }, textStyle.defaultTextDescription)
    }, !isEmailAdded ? /*#__PURE__*/React.createElement(Link, {
      to: "/Account/ContactInformation"
    }, translations.OptInOut_AddOrConfirmEmail) : /*#__PURE__*/React.createElement("span", null, userEmail)), /*#__PURE__*/React.createElement(PnmacParagraph, {
      style: __assign({
        marginTop: 10
      }, textStyle.defaultTextDescription)
    }, !isPhoneAdded ? /*#__PURE__*/React.createElement(Link, {
      to: "/Account/ContactInformation"
    }, translations.AddConfirmMobilePhoneNumber) : /*#__PURE__*/React.createElement("span", null, userPhone)))), /*#__PURE__*/React.createElement(View, {
      style: {
        width: "100%",
        height: 1,
        backgroundColor: '#e9e9e9',
        marginTop: 20,
        marginBotom: 40
      }
    }), /*#__PURE__*/React.createElement(View, {
      style: {
        flexDirection: matches.small ? 'column' : 'row',
        paddingTop: 10,
        paddingBottom: 10,
        width: "100%"
      }
    }, /*#__PURE__*/React.createElement(View, {
      style: {
        flex: 1
      }
    }, /*#__PURE__*/React.createElement(PnmacText, {
      style: [textStyle.defaultTextDescription, styles.fontSizeStyle]
    }, translations.OptInOut_LoanServicing), /*#__PURE__*/React.createElement(PnmacText, {
      style: [textStyle.defaultTextDescription, styles.fontSizeStyle, {
        color: "#B4B4B4"
      }]
    }, translations.OptInOut_LoanServicingInfo), /*#__PURE__*/React.createElement(View, {
      style: {
        flexDirection: 'row',
        justifyContent: "space-between",
        width: "35%",
        marginTop: 25
      }
    }, /*#__PURE__*/React.createElement(View, {
      style: {
        justifyContent: "center"
      }
    }, /*#__PURE__*/React.createElement(PnmacText, {
      style: [textStyle.defaultTextTitle, styles.fontSizeStyle]
    }, translations.Email), /*#__PURE__*/React.createElement(PnmacCheckBox, {
      enject: true,
      disabled: !isEmailAdded,
      onPress: function () {
        setLoanServicingEmail(!loanServicingEmail);
        setNoChange(false);
      },
      status: getRadioButtonStatus(loanServicingEmail)
    })), /*#__PURE__*/React.createElement(View, {
      style: {
        justifyContent: "center"
      }
    }, /*#__PURE__*/React.createElement(PnmacText, {
      style: [textStyle.defaultTextTitle, styles.fontSizeStyle]
    }, translations.OptInOut_TextSMS), /*#__PURE__*/React.createElement(PnmacCheckBox, {
      disabled: !isPhoneAdded,
      enject: true,
      onPress: function () {
        setLoanServicingMobile(!loanServicingMobile);
        setNoChange(false);
      },
      status: getRadioButtonStatus(loanServicingMobile)
    })))), /*#__PURE__*/React.createElement(View, {
      style: {
        width: matches.small ? '100%' : 1,
        height: matches.small ? 1 : "100%",
        backgroundColor: "#e9e9e9",
        marginStart: matches.small ? 0 : 10,
        marginEnd: matches.small ? 0 : 10,
        marginBotom: matches.small ? 10 : 0,
        marginTop: matches.small ? 10 : 0
      }
    }), /*#__PURE__*/React.createElement(View, {
      style: {
        flex: 1,
        marginTop: matches.small ? 10 : 0
      }
    }, /*#__PURE__*/React.createElement(PnmacText, {
      style: [textStyle.defaultTextDescription, styles.fontSizeStyle]
    }, translations.OptInOut_DigitalAlerts), /*#__PURE__*/React.createElement(PnmacHtmlToNative, {
      value: translations === null || translations === void 0 ? void 0 : translations.OptInOut_DigitalAlertsInfo,
      layout: layout,
      navigation: navigation
    }), /*#__PURE__*/React.createElement(View, {
      style: {
        flexDirection: 'row',
        justifyContent: "space-between",
        width: "35%",
        marginTop: 10
      }
    }, /*#__PURE__*/React.createElement(View, {
      style: {
        justifyContent: "center"
      }
    }, /*#__PURE__*/React.createElement(PnmacText, {
      style: [textStyle.defaultTextTitle, styles.fontSizeStyle]
    }, translations.Email), /*#__PURE__*/React.createElement(PnmacCheckBox, {
      disabled: !isEmailAdded,
      enject: true,
      onPress: function () {
        setDigitalAlertEmail(digitalAlertMobile ? !digitalAlertEmail : true);
        setNoChange(false);
      },
      status: getRadioButtonStatus(digitalAlertEmail)
    })), /*#__PURE__*/React.createElement(View, {
      style: {
        justifyContent: "center"
      }
    }, /*#__PURE__*/React.createElement(PnmacText, {
      style: [textStyle.defaultTextTitle, styles.fontSizeStyle]
    }, translations.OptInOut_TextSMS), /*#__PURE__*/React.createElement(PnmacCheckBox, {
      disabled: !isPhoneAdded,
      enject: true,
      onPress: function () {
        setDigitalAlertMobile(digitalAlertEmail ? !digitalAlertMobile : true);
        setNoChange(false);
      },
      status: getRadioButtonStatus(digitalAlertMobile)
    })))), /*#__PURE__*/React.createElement(View, {
      style: {
        width: matches.small ? '100%' : 1,
        height: matches.small ? 1 : "100%",
        backgroundColor: "#e9e9e9",
        marginStart: matches.small ? 0 : 10,
        marginEnd: matches.small ? 0 : 10,
        marginBotom: matches.small ? 10 : 0,
        marginTop: matches.small ? 10 : 0
      }
    }), /*#__PURE__*/React.createElement(View, {
      style: {
        flex: 1,
        marginTop: matches.small ? 10 : 0
      }
    }, /*#__PURE__*/React.createElement(PnmacText, {
      style: [textStyle.defaultTextDescription, styles.fontSizeStyle]
    }, translations.OptInOut_PaymentReminders), /*#__PURE__*/React.createElement(PnmacText, {
      style: [textStyle.defaultTextDescription, styles.fontSizeStyle, {
        color: "#B4B4B4"
      }]
    }, translations.OptInOut_PaymentRemindersInfo), /*#__PURE__*/React.createElement(View, {
      style: {
        flexDirection: 'row',
        marginTop: 10
      }
    }, /*#__PURE__*/React.createElement(View, {
      style: {
        flexDirection: 'row',
        justifyContent: "space-between",
        width: "35%",
        marginEnd: 20
      }
    }, /*#__PURE__*/React.createElement(View, {
      style: {
        justifyContent: "center"
      }
    }, /*#__PURE__*/React.createElement(PnmacText, {
      style: [textStyle.defaultTextTitle, styles.fontSizeStyle]
    }, translations.Email), /*#__PURE__*/React.createElement(PnmacCheckBox, {
      disabled: !isEmailAdded,
      enject: true,
      onPress: function () {
        var payDay = paymentReminderDay;
        setNoChange(!(parseInt(payDay) > 0));
        setPaymentReminderEmail(!paymentReminderEmail);
        if (!paymentReminderEmail === false && paymentReminderMobile === false) {
          isPaymentPreferenceUpdated.current = true;
          setPaymentReminderDay(0);
        } else {
          isPaymentPreferenceUpdated.current = false;
        }
      },
      status: getRadioButtonStatus(paymentReminderEmail)
    })), /*#__PURE__*/React.createElement(View, {
      style: {
        justifyContent: "center"
      }
    }, /*#__PURE__*/React.createElement(PnmacText, {
      style: [textStyle.defaultTextTitle, styles.fontSizeStyle]
    }, translations.OptInOut_TextSMS), /*#__PURE__*/React.createElement(PnmacCheckBox, {
      enject: true,
      disabled: !isPhoneAdded,
      onPress: function () {
        var payDay = paymentReminderDay;
        setNoChange(!(parseInt(payDay) > 0));
        setPaymentReminderMobile(!paymentReminderMobile);
        if (paymentReminderEmail === false && !paymentReminderMobile === false) {
          isPaymentPreferenceUpdated.current = true;
          setPaymentReminderDay(0);
        } else {
          isPaymentPreferenceUpdated.current = false;
        }
      },
      status: getRadioButtonStatus(paymentReminderMobile)
    }))), /*#__PURE__*/React.createElement(View, {
      style: {
        marginTop: 5
      }
    }, /*#__PURE__*/React.createElement(PnmacText, {
      style: [textStyle.defaultTextTitle, styles.fontSizeStyle]
    }, " ", translations.OptInOut_ReminderDate, " "), /*#__PURE__*/React.createElement(View, {
      style: {
        marginTop: 5
      }
    }, /*#__PURE__*/React.createElement(PnmacSelect, {
      accessibilityLabel: "Payment Reminder Month",
      idTag1: 'dropDownPaymentReminderMonth',
      placeholder: {
        label: 'Select a date',
        value: 0,
        color: 'black'
      },
      items: getDatesForDayPicker(),
      onValueChange: function (value) {
        if (isPaymentPreferenceUpdated.current === false) {
          setNoChange((paymentReminderEmail || paymentReminderMobile) && parseInt(value) > 0 ? false : true);
        }
        setPaymentReminderDay(parseInt(value));
      },
      disabled: disablePaymentReminderDayPicker(),
      InputAccessoryView: function () {
        return null;
      },
      value: paymentReminderDay,
      customStyles: styles.pickerCustomStyle
    })))))), /*#__PURE__*/React.createElement(View, {
      style: {
        alignSelf: matches.small ? 'center' : 'flex-end',
        width: matches.small ? '80%' : '25%',
        marginTop: 40,
        marginBotom: 40
      }
    }, /*#__PURE__*/React.createElement(PnmacUIButton, {
      mode: 'contained',
      idTag1: 'btnNotificationView',
      loading: loading,
      disabled: noChange,
      onPress: function () {
        return updateData();
      }
    }, 'Save'))))));
  });
};
export default CommunicationNotificationView;
var styles = StyleSheet.create({
  pickerCustomStyle: {
    fontSize: 16,
    paddingHorizontal: 10,
    paddingVertical: 8,
    borderWidth: 0.5,
    borderColor: 'gray',
    borderRadius: 8,
    color: 'black',
    paddingRight: 30
  },
  fontSizeStyle: {
    fontSize: 12
  }
});